module.exports = __webpack_public_path__ + "static/media/Screenshot_1-thumb.d2b2c9d9.png";